import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';
import { HttpClientModule } from '@angular/common/http';
import { ForgotPasswordComponent } from './authentication/forgot-password/forgot-password.component';
import { GuestComponent } from './theme/layout/guest/guest.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard], 
    children: [
      {
        path: '',
        redirectTo: '/sample-page',
        pathMatch: 'full'
      },
      {
        path: 'sample-page',
        loadComponent: () => 
          import('./demo/sample-page/sample-page.component').then((c) => c.SamplePageComponent),
        canActivate: [AuthGuard] 
      },
      {
        path: 'profile',
        loadComponent: () => 
          import('./user/profile/profile.component').then((c) => c.ProfileComponent),
        canActivate: [AuthGuard] 
      },
      {
        path: 'upload-products',
        loadComponent: () => 
          import('./user/upload-products/upload-products.component' ).then((c) => c.UploadProductsComponent),
        canActivate: [AuthGuard] 
      },
      {
        path: 'download-products',
        loadComponent: () => 
          import('./user/downloads-products/downloads-products.component' ).then((c) => c.DownloadsProductsComponent),
        canActivate: [AuthGuard] 
      },
    
     
      // {
      //   path: 'admin-dashboard',
      //   loadComponent: () => 
      //     import('./demo/admin-dashboard/admin-dashboard.component').then((c) => c.AdminDashboardComponent),
      //   canActivate: [AuthGuard, RoleGuard], // Protegido por autenticación y roles
      //   data: { roles: ['admin'] } // Solo accesible para administradores
      // }
    ]
  },
  {
    path: 'authentication',
    component: GuestComponent,
    children: [
      {
        path: 'login',
        loadComponent: () => 
          import('./authentication/login/login.component').then((c) => c.LoginComponent)
      }
    ]
  },
  {
    path: 'forgot-password', 
    loadComponent: () => 
      import('./authentication/forgot-password/forgot-password.component').then((c) => c.ForgotPasswordComponent)
  },
  {
    path: 'resetPassword', 
    loadComponent: () => 
      import('./authentication/reset-password/reset-password.component').then((c) => c.ResetPasswordComponent)
  },
  { path: '**', redirectTo: '/sample-page' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
